import "core-js/stable";
import "regenerator-runtime/runtime";
import Rails from "@rails/ujs";
import { goToItemOnTableRowClick } from "~/src/adminTables";
import adminAppointments from "~/src/adminAppointments";
import adminHubPages from "~/src/adminHubPages";
import adminPolls from "~/src/adminPolls";
import appointmentsSidebarForm from "~/src/appointmentsSidebarForm";
import productForm from "~/src/productForm";
import attributeFilters from "~/src/attributeFilters";
import ticketChannels from "~/src/ticketChannels";
import groupsAutocomplete from "~/src/groups/autocomplete";
import { sessionPopup } from "~/src/sessionPopup";
import ChannelsPicklist from "~/src/picklist/channelsPicklist";
import loadSelect2ForMultiselect from "~/src/adminComponents/multiselect";
import loadSelect2ForMultiselectAjax from "~/src/adminComponents/multiselectAjax";
import loadSelect2ForSelect from "~/src/adminComponents/select";
import loadSelect2ForSelectAjax from "~/src/adminComponents/selectAjax";
import initMinicolors from "~/src/minicolors";
import sortingArrows from "~/src/sorting_arrows";
import simpleAccordion from "~/src/simple_accordion";
import orderRegistrationFields from "../src/registrationFields/fieldsOrdering";
import modifyRegistrationFields from "../src/registrationFields/modifyField";

if (!window._rails_loaded) {
  Rails.start();
}

ChannelsPicklist.init();
adminAppointments();
adminHubPages();
adminPolls();
appointmentsSidebarForm();
attributeFilters();
goToItemOnTableRowClick(".group-row");
goToItemOnTableRowClick(".poll-row");
goToItemOnTableRowClick(".product-row");
goToItemOnTableRowClick(".event-row");
goToItemOnTableRowClick(".crud-table-row");
groupsAutocomplete(".groups-users-table-email-input", "user", "email");
groupsAutocomplete(".groups-users-table__email", "user", "email", true);
groupsAutocomplete(".groups-products-table-name-input", "product", "name");
groupsAutocomplete(".groups-products-table-title-input", "product", "title");
groupsAutocomplete(".groups-products-table__name", "product", "name", true);
groupsAutocomplete(".groups-hub-pages-table-name-input", "hub_page", "name");
groupsAutocomplete(".groups-hub-pages-table__name", "hub_page", "name", true);
groupsAutocomplete(".groups-locations-table-name-input", "location", "name");
groupsAutocomplete(".groups-locations-table__name", "location", "name", true);
groupsAutocomplete(".groups-polls-table-name-input", "poll", "name");
groupsAutocomplete(".groups-polls-table__name", "poll", "name", true);
groupsAutocomplete(".groups-streams-table-name-input", "stream", "name");
groupsAutocomplete(".groups-streams-table__name", "stream", "name", true);
initMinicolors("input[type=text]#event_group_color");
initMinicolors("input[type=text]#cluster_ribbon_color");
initMinicolors("input[type=text]#competency_color");
initMinicolors("input[type=text]#custom_image_upload_font_color");
initMinicolors("#reset_pass_url_font_color");
initMinicolors("input[type=text]#stream_color");
loadSelect2ForMultiselect();
loadSelect2ForMultiselectAjax();
loadSelect2ForSelect();
loadSelect2ForSelectAjax();
modifyRegistrationFields();
orderRegistrationFields();
productForm();
sessionPopup();
simpleAccordion();
sortingArrows();
ticketChannels();
